/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Exported_Csv_ToastInputs */

const en_compare_event_groups_exported_csv_toast = /** @type {(inputs: Compare_Event_Groups_Exported_Csv_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparison exported to CSV`)
};

const fr_compare_event_groups_exported_csv_toast = /** @type {(inputs: Compare_Event_Groups_Exported_Csv_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparaison exportée en CSV`)
};

const de_compare_event_groups_exported_csv_toast = /** @type {(inputs: Compare_Event_Groups_Exported_Csv_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleich als CSV exportiert`)
};

const it_compare_event_groups_exported_csv_toast = /** @type {(inputs: Compare_Event_Groups_Exported_Csv_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronto esportato in CSV`)
};

const ru_compare_event_groups_exported_csv_toast = /** @type {(inputs: Compare_Event_Groups_Exported_Csv_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнение экспортировано в CSV-файл.`)
};

const es_compare_event_groups_exported_csv_toast = /** @type {(inputs: Compare_Event_Groups_Exported_Csv_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparación exportada a CSV`)
};

const zh_cn2_compare_event_groups_exported_csv_toast = /** @type {(inputs: Compare_Event_Groups_Exported_Csv_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比结果已导出为 CSV 文件`)
};

const ja_compare_event_groups_exported_csv_toast = /** @type {(inputs: Compare_Event_Groups_Exported_Csv_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比較をCSVにエクスポート`)
};

const hi_compare_event_groups_exported_csv_toast = /** @type {(inputs: Compare_Event_Groups_Exported_Csv_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तुलना को CSV में निर्यात किया गया`)
};

const pt_pt2_compare_event_groups_exported_csv_toast = /** @type {(inputs: Compare_Event_Groups_Exported_Csv_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparação exportada para CSV`)
};

/**
* | output |
* | --- |
* | "Comparison exported to CSV" |
*
* @param {Compare_Event_Groups_Exported_Csv_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_exported_csv_toast = /** @type {((inputs?: Compare_Event_Groups_Exported_Csv_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Exported_Csv_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_exported_csv_toast(inputs)
	if (locale === "de") return de_compare_event_groups_exported_csv_toast(inputs)
	if (locale === "it") return it_compare_event_groups_exported_csv_toast(inputs)
	if (locale === "ru") return ru_compare_event_groups_exported_csv_toast(inputs)
	if (locale === "es") return es_compare_event_groups_exported_csv_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_exported_csv_toast(inputs)
	if (locale === "ja") return ja_compare_event_groups_exported_csv_toast(inputs)
	if (locale === "hi") return hi_compare_event_groups_exported_csv_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_exported_csv_toast(inputs)
	return en_compare_event_groups_exported_csv_toast(inputs)
});